import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuthStore } from "../../store/authStore";
import { refreshIngest } from "../../api/services";
import {
  IconGrid, IconMoney, IconFunnel, IconBox, IconBulb, IconBoard,
  IconUsers, IconChart, IconVideo, IconSettings, IconRefresh, IconLogout, IconTarget,
} from "../common/Icons";
import styles from "./Layout.module.css";

const NAV = [
  { to: "/", label: "Обзор", icon: IconGrid, end: true },
  { to: "/revenue", label: "Выручка и цель", icon: IconMoney },
  { to: "/funnel", label: "Воронка", icon: IconFunnel },
  { to: "/products", label: "Продукты", icon: IconBox },
  { to: "/hypotheses", label: "Гипотезы", icon: IconBulb },
  { to: "/board", label: "Канбан", icon: IconBoard },
  { to: "/segments", label: "Сегменты ЦА", icon: IconUsers },
  { to: "/traffic", label: "Трафик", icon: IconChart },
  { to: "/tiktok", label: "TikTok", icon: IconVideo },
  { to: "/settings", label: "Настройки", icon: IconSettings },
];

export default function Layout({ children }) {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();
  const [refreshing, setRefreshing] = useState(false);
  const [status, setStatus] = useState(null);

  const doRefresh = async () => {
    setRefreshing(true);
    try {
      const res = await refreshIngest("all");
      setStatus(res.status);
      // мягко перезагрузить текущую страницу-данные
      window.dispatchEvent(new CustomEvent("ingest-done"));
    } catch {
      setStatus("failed");
    } finally {
      setRefreshing(false);
    }
  };

  return (
    <div className={styles.shell}>
      <aside className={styles.sidebar}>
        <div className={styles.brand}>
          <IconTarget width={22} height={22} />
          <span>Акселерация</span>
        </div>
        <nav className={styles.nav}>
          {NAV.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) => `${styles.navItem} ${isActive ? styles.active : ""}`}
              >
                <Icon width={18} height={18} />
                <span>{item.label}</span>
              </NavLink>
            );
          })}
        </nav>
        <div className={styles.sideFoot}>
          <div className={styles.userRow}>
            <div>
              <div className={styles.userName}>{user?.username}</div>
              <div className={styles.userRole}>{user?.role === "tracker" ? "трекер" : "основатель"}</div>
            </div>
            <button
              className={styles.logout}
              title="Выйти"
              onClick={() => { logout(); navigate("/login"); }}
            >
              <IconLogout width={17} height={17} />
            </button>
          </div>
        </div>
      </aside>

      <div className={styles.main}>
        <header className={styles.topbar}>
          <div className={styles.topStatus}>
            {status && (
              <span className={styles.ingestStatus}>
                Последний сбор: {status === "ok" ? "успех" : status === "partial" ? "частично" : "ошибка"}
              </span>
            )}
          </div>
          <button className={styles.refresh} onClick={doRefresh} disabled={refreshing}>
            <IconRefresh width={16} height={16} />
            {refreshing ? "Сбор данных…" : "Обновить данные"}
          </button>
        </header>
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
}
